"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpoints = void 0;
exports.searchAttachments = searchAttachments;
exports.searchHints = searchHints;
exports.searchMessages = searchMessages;
exports.searchRecommendations = searchRecommendations;
exports.searchThreads = searchThreads;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var endpoints = exports.endpoints = {
  searchMessages: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/message");
    }
  },
  searchThreads: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/thread");
    }
  },
  searchHints: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/hint");
    }
  },
  recommendations: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/recommendations");
    }
  },
  searchAttachments: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/search/attachment");
    }
  }
};
/**
 * Search thread
 *
 * @public
 *
 * @param {string} q - serach query
 * @param {Auth} auth - Auth token
 * @param {string} timezone Optional, default to server’s timezone
 * @param {string} pageToken The page token to start retrieving result
 * @param {number} maxResults Optional, default to 20
 * @returns {Promise<SearchThreadResponse>}
 */
function searchThreads(_x, _x2) {
  return _searchThreads.apply(this, arguments);
}
function _searchThreads() {
  _searchThreads = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref, rest) {
    var q, auth, timezone, pageToken, _ref$maxResults, maxResults, prioritizeLabels, optionals, _endpoints$searchThre, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          q = _ref.q, auth = _ref.auth, timezone = _ref.timezone, pageToken = _ref.pageToken, _ref$maxResults = _ref.maxResults, maxResults = _ref$maxResults === void 0 ? 30 : _ref$maxResults, prioritizeLabels = _ref.prioritizeLabels;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            timezone: timezone,
            pageToken: pageToken,
            maxResults: maxResults,
            prioritizeLabels: prioritizeLabels
          }), (0, _requests.withBody)(q), (0, _utils.withOptionals)(rest))(_utils.defaultOptionals);
          _endpoints$searchThre = endpoints.searchThreads, method = _endpoints$searchThre.method, url = _endpoints$searchThre.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _searchThreads.apply(this, arguments);
}
/**
 * Search message
 *
 * @public
 *
 * @param {string} q - serach query
 * @param {Auth} auth - Auth token
 * @param {string} timezone Optional, default to server’s timezone
 * @param {string} pageToken The page token to start retrieving result
 * @param {number} maxResults Optional, default to 20
 * @returns {Promise<SearchMessageResponse>}
 */
function searchMessages(_x3, _x4) {
  return _searchMessages.apply(this, arguments);
}
function _searchMessages() {
  _searchMessages = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, rest) {
    var q, auth, timezone, pageToken, maxResults, prioritizeLabels, optionals, _endpoints$searchMess, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          q = _ref2.q, auth = _ref2.auth, timezone = _ref2.timezone, pageToken = _ref2.pageToken, maxResults = _ref2.maxResults, prioritizeLabels = _ref2.prioritizeLabels;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            timezone: timezone,
            pageToken: pageToken,
            maxResults: maxResults,
            prioritizeLabels: prioritizeLabels
          }), (0, _requests.withBody)(q), (0, _utils.withOptionals)(rest))(_utils.defaultOptionals);
          _endpoints$searchMess = endpoints.searchMessages, method = _endpoints$searchMess.method, url = _endpoints$searchMess.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _searchMessages.apply(this, arguments);
}
/**
 * Search hints.
 *
 * @public
 *
 * @param {string} q - search query
 * @param {Auth} auth - Auth token
 * @param {string} timezone Optional, default to server’s timezone
 * @param {number} maxResults Optional, default to 10
 * @returns {Promise<SearchHintsResponse>}
 */
function searchHints(_x5, _x6) {
  return _searchHints.apply(this, arguments);
}
function _searchHints() {
  _searchHints = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3, rest) {
    var q, auth, timezone, maxResults, optionals, _endpoints$searchHint, method, url, res;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          q = _ref3.q, auth = _ref3.auth, timezone = _ref3.timezone, maxResults = _ref3.maxResults;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            q: q,
            timezone: timezone,
            maxResults: maxResults
          }), (0, _utils.withOptionals)(rest))(_utils.defaultOptionals);
          _endpoints$searchHint = endpoints.searchHints, method = _endpoints$searchHint.method, url = _endpoints$searchHint.url;
          _context3.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 7:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _searchHints.apply(this, arguments);
}
function searchRecommendations(_x7) {
  return _searchRecommendations.apply(this, arguments);
}
function _searchRecommendations() {
  _searchRecommendations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref4) {
    var auth,
      rest,
      optionals,
      _endpoints$recommenda,
      method,
      url,
      res,
      _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          auth = _ref4.auth;
          rest = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth))(_utils.defaultOptionals);
          _endpoints$recommenda = endpoints.recommendations, method = _endpoints$recommenda.method, url = _endpoints$recommenda.url;
          _context4.next = 6;
          return (0, _requests.request)(url(), method, optionals);
        case 6:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 8:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _searchRecommendations.apply(this, arguments);
}
/**
 * Search attachment
 *
 * @public
 *
 * @param {string} q - serach query
 * @param {Auth} auth - Auth token
 * @param {string} timezone Optional, default to server’s timezone
 * @param {string} pageToken The page token to start retrieving result
 * @param {AttachmentSearchType} type Optional, default to 'all'
 * @param {number} pageSize Optional, default to 20
 * @returns {Promise<SearchMessageResponse>}
 */
function searchAttachments(_x8, _x9) {
  return _searchAttachments.apply(this, arguments);
}
function _searchAttachments() {
  _searchAttachments = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(_ref5, rest) {
    var fileName, auth, timezone, pageToken, _ref5$type, type, _ref5$otherEmail, otherEmail, _ref5$pageSize, pageSize, _ref5$incDraft, incDraft, optionals, _endpoints$searchAtta, method, url, res;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          fileName = _ref5.fileName, auth = _ref5.auth, timezone = _ref5.timezone, pageToken = _ref5.pageToken, _ref5$type = _ref5.type, type = _ref5$type === void 0 ? 'all' : _ref5$type, _ref5$otherEmail = _ref5.otherEmail, otherEmail = _ref5$otherEmail === void 0 ? '' : _ref5$otherEmail, _ref5$pageSize = _ref5.pageSize, pageSize = _ref5$pageSize === void 0 ? 20 : _ref5$pageSize, _ref5$incDraft = _ref5.incDraft, incDraft = _ref5$incDraft === void 0 ? false : _ref5$incDraft;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            fileName: fileName,
            timezone: timezone,
            pageToken: pageToken,
            type: type,
            pageSize: pageSize,
            otherEmail: otherEmail,
            incDraft: incDraft
          }), (0, _utils.withOptionals)(rest))(_utils.defaultOptionals);
          _endpoints$searchAtta = endpoints.searchAttachments, method = _endpoints$searchAtta.method, url = _endpoints$searchAtta.url;
          _context5.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _searchAttachments.apply(this, arguments);
}
//# sourceMappingURL=search.js.map